import React, { useContext, useMemo, useState } from "react";

import { useNavigate } from "react-router-dom";
import { Group, Space, Title, Card, Grid, Tooltip, Badge, ThemeIcon, Menu, Modal, Stack, Paper, Text, Checkbox } from "@mantine/core";
import { BsPlusCircle } from "react-icons/bs";
import { Button } from "@mantine/core";
import SendSMSModal from "../../components/send_sms_modal";
import CustomModal from "../../components/custom_modal";
import RequestKYCUpdate from "../requestKYCUpdate";
import GeneratePDFModal from "../../components/generate_pdf_modal";
import { IconDownload, IconEye, IconMessage, IconUpload, } from "@tabler/icons-react";
import CustomerInstantSearch from "../../components/customer_instant_search";
import { Action, ActionType, BaseResult, CustomClaims, Customer, } from "../../types";
import { Timestamp, collection, getDocs, orderBy, query } from "firebase/firestore";
import CustomListActionsModal from "../../components/custom_actions_modal";
import { httpsCallable } from "firebase/functions";
import { useFirestore, useFunctions } from "../../helpers/firebaseContext";
import { MyUserDataContext } from "../../contexts";
import GenerateConfirmedOrdersCSVModal from "../../components/generate_confirmed_orders_csv_modal";
import { openConfirmModal } from "@mantine/modals";

import UploadCustomerModal from "./UploadCustomerModal";
import GenerateKycCSVModal from "../../components/generate_kyc_csv_modal";
import GenerateBurganExcelModal from "../../components/generate_burgan_excel_modal";
import SendPromotionalMaterial from "../../components/promotional_materials_modal";
import { useCanSendPromotionalMaterial } from "../../helpers/useCanSendPromotionalMaterial";
interface ActionsComponentProps {
  customerObj: Customer;
}
const CustomersListTypesense = () => {


  const navigate = useNavigate();
  const functions = useFunctions();
  const db = useFirestore();
  const canSendPromotionalMaterial = useCanSendPromotionalMaterial();

  const [SMSOpened, setSMSOpened] = useState(false);
  const [generatePDFOpen, setGeneratePDFOpen] = useState(false);
  const [kycStatusUpdateOpen, setKycStatusUpdateOpen] = useState(false);
  const [addClientModal, setAddClientModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [generateCSVOpen, setGenerateCSVOpen] = useState(false);
  const [generateCustomersCSVOpen, setCustomersGenerateCSVOpen] = useState(false);
  const [promotionalMaterialModalOpen, setPromotionalMaterialModalOpen] = useState<boolean>(false);
  const [generateCustomersBurganExcelOpen, setCustomersGenerateBurganExcelOpen] = useState(false);

  const kycAction = httpsCallable<Action, BaseResult>(functions, "kycAction");

  const [tableClearTrigger, setTableClearTrigger] = useState(0);

  const renderPromotionalMaterialModal = React.useMemo(() => {
    return <SendPromotionalMaterial
      opened={promotionalMaterialModalOpen}
      setOpened={setPromotionalMaterialModalOpen}

    />;
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [

      promotionalMaterialModalOpen,
    ]);
  const RenderActions = ({ customerObj }: ActionsComponentProps) => {

    // console.log("customerObj ====>>>", customerObj);
    //if it came from typesense search, then the object is going to be incorrect and date won't be in Timestamp format
    if (customerObj.lastUnsubmittedKYCMessage?.date && !(customerObj.lastUnsubmittedKYCMessage.date instanceof Timestamp)) {
      customerObj.lastUnsubmittedKYCMessage.date = new Timestamp(customerObj.lastUnsubmittedKYCMessage.date as any, 0);
    }


    return <Group>
      {/*   TODO: Yousef: Disabling this for now until we can implement it properly
        <Menu
          position="bottom-start"
          withArrow
          arrowPosition="center"
        >
          <Menu.Target>
  
            <UnstyledButton pr={12}> <IconDots />
  
  
            </UnstyledButton>
  
          </Menu.Target>
          <Menu.Dropdown>
  
            <Menu.Item
              leftSection={<IconDeviceMobileMessage size={16} color={theme.colors.blue[6]} stroke={1.5} />}
              onClick={async () => {
                return;
              }
              }
            >
              SMS
            </Menu.Item>
            <Menu.Item
              leftSection={<IconCashBanknote size={16} color={theme.colors.blue[6]} stroke={1.5} />}
              onClick={() => {
                navigate(`/transactions/add/`, { state: { type: "cash_in", customer: customerObj.id } });
              }}
            >
  
              Cash in
            </Menu.Item>
            <Menu.Item
              leftSection={<IconCashBanknote size={16} color={theme.colors.blue[6]} stroke={1.5} />}
              onClick={() => {
                navigate(`/transactions/add/`, { state: { type: "cash_out", customer: customerObj } });
              }}
            >
              Cash out
            </Menu.Item>
            <Menu.Item
              leftSection={<IconCertificate size={16} color={theme.colors.blue[6]} stroke={1.5} />}
              onClick={() => {
                navigate(`/transactions/add/`, { state: { type: "security_in", customer: customerObj.id } });
              }}
            >
              Security In
            </Menu.Item>
            <Menu.Item
              leftSection={
                <IconCertificate2 size={16} color={theme.colors.blue[6]} stroke={1.5} />
              }
              onClick={() => {
                navigate(`/transactions/add/`, { state: { type: "security_out", customer: customerObj.id } });
              }}
            >
              Security Out
            </Menu.Item>
            <Menu.Item
              leftSection={
                <IconCertificate2 size={16} color={theme.colors.blue[6]} stroke={1.5} />
              }
              onClick={() => {
                navigate(`/transactions/add/`, { state: { type: "fx", customer: customerObj.id } });
              }}
            >
              FX + Transfer
            </Menu.Item>
            <Menu.Item
              leftSection={
                <IconShoppingCartPlus size={16} color={theme.colors.blue[6]} stroke={1.5} />
              }
  
              onClick={() => {
                navigate(`/add_order/${customerObj.civilID}`);
              }}
            >
              Add Order
            </Menu.Item>
  
  
          </Menu.Dropdown>
  
        </Menu> */}

      <ThemeIcon color="blue" variant="light" onClick={() => {
        navigate("/customers/" + customerObj.id, { state: customerObj })
      }}><IconEye size={16} /></ThemeIcon>

      {customerObj.lastUnsubmittedKYCMessage?.count ? <>
        <Tooltip
          w={220}
          multiline
          label={`Number of KYC requests with no response: (${customerObj.lastUnsubmittedKYCMessage?.count}),
                          Last request sent(${customerObj.lastUnsubmittedKYCMessage.date.toDate().toLocaleString("en-GB", { hour12: true })}) `} >

          <Badge size="xs" color="red">{customerObj.lastUnsubmittedKYCMessage?.count}</Badge>
        </Tooltip>
      </> : null}

    </Group>

  }
  const userData = useContext(MyUserDataContext);

  let customClaims = userData.firebaseTokenResult?.claims.customClaims as CustomClaims;


  //don't show top bar for kfh_rm and kfh_oper
  const topElements = !customClaims.kfh_rm && !customClaims.kfh_oper ? (<Group>
    <Button
      color="grape"
      disabled={selectedRows.length === 0}
      onClick={() => setSMSOpened(true)}
    >
      Send SMS to {selectedRows.length} customers
    </Button>


    {/* <Button c="orange" loading={approvingAll} onClick={() => {setApprovingAll(true); console.log("ey");}}>Approve all</Button> */}
    {/* <Button
      color="yellow"
      disabled={selectedRows.length === 0}
      onClick={() => setGeneratePDFOpen(true)}
    >
      {`Generate KYC for ${selectedRows.length} customers`}
    </Button> */}
    <Button
      color="lime"
      disabled={selectedRows.length === 0}
      onClick={() => setKycStatusUpdateOpen(true)}
    >
      {`Change KYC status for ${selectedRows.length} customer(s)`}
    </Button>

    {/* {(customClaims.admin || customClaims.oper) && <Button
      color="lime"

      onClick={() => setCustomersGenerateCSVOpen(true)}
    >
      {`Generate Customers  CSV`}
    </Button>} */}
    {/* {(customClaims.admin || customClaims.oper) && <Button
      color="pink"
      // disabled={selectedRows.length === 0}
      onClick={() => setGenerateCSVOpen(true)}
    >
      {`Completed Orders CSV`}
    </Button>} */}

    {/* <Button
      color="lime"

      onClick={() => openConfirmModal({
        confirmProps: {
          hidden: true,
          display: "none"
        },
        cancelProps: {
          hidden: true,
          display: "none"

        },
        title: 'Upload Customers CSV',
        children: <UploadCustomerModal />

      })}
    >

      {`Upload Customers CSV`}
    </Button> */}
    <Menu shadow="md" width={200}>
      <Menu.Target>
        <Button>Import / Export</Button>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Label>Import</Menu.Label>
        <Menu.Item
          onClick={() => openConfirmModal({
            confirmProps: {
              hidden: true,
              display: "none"
            },
            cancelProps: {
              hidden: true,
              display: "none"

            },
            title: 'Upload Customers CSV',
            children: <UploadCustomerModal />

          })}
          leftSection={<IconUpload size={14} />}>
          Upload Customers CSV
        </Menu.Item>

        <Menu.Divider />

        <Menu.Label>Export</Menu.Label>
        {(customClaims.admin || customClaims.oper) && <Menu.Item
          onClick={() => setCustomersGenerateCSVOpen(true)}
          leftSection={<IconDownload size={14} />}
        >
          Generate Customers CSV
        </Menu.Item>}
        {(customClaims.admin || customClaims.oper) && <Menu.Item
          onClick={() => setCustomersGenerateBurganExcelOpen(true)}
          leftSection={<IconDownload size={14} />}
        >
          Generate Burgan Excel
        </Menu.Item>}
        {/* <GenerateBurganExcelButton /> */}
        {(customClaims.admin || customClaims.oper) && <Menu.Item
          onClick={() => setGenerateCSVOpen(true)}
          leftSection={<IconDownload size={14} />}
        >
          Completed Orders CSV
        </Menu.Item>}
        <Menu.Item
          disabled={selectedRows.length === 0}
          onClick={() => setGeneratePDFOpen(true)}

          leftSection={<IconDownload size={14} />}
        >
          {`Generate KYC for ${selectedRows.length} customers`}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  </Group>) : undefined;


  const searchableCustomers = useMemo(() => <CustomerInstantSearch
    setSelectedRows={setSelectedRows}
    selectable={true}
    selectedRows={selectedRows}
    renderTags={true}
    navigateDetails={(obj: any) =>
      navigate("/customers/" + obj.id, { state: obj })
    }
    ActionsComponent={RenderActions}
    indexName={import.meta.env.VITE_TYPESENSE_CUSTOMERS_COLLECTION!}
    topElements={topElements}
    clearTrigger={tableClearTrigger}
  />,
    // eslint-disable-next-line 
    [selectedRows]);

  const customerModals = useMemo(() => <>
    <SendSMSModal
      rows={selectedRows}
      opened={SMSOpened}
      setOpened={setSMSOpened}
    />
    <GeneratePDFModal
      generatingForCollection="customer"
      rows={selectedRows}
      opened={generatePDFOpen}
      setOpened={setGeneratePDFOpen}
      includeKYC={true}
    />

    <CustomModal
      title={<Title>Add Client</Title>}
      opened={addClientModal}
      // setOpened={setAddClientModal`}
      onClose={() => setAddClientModal(false)}
      // overlayOpacity={0.22}
      // overlayBlur={3}
      centered
    >
      <RequestKYCUpdate setModal={setAddClientModal} />
    </CustomModal>
    <CustomListActionsModal<Customer>
      rows={selectedRows}
      handleClose={() => {
        setSelectedRows([]);
        // Force table to clear by changing a key
        setTableClearTrigger(prev => prev + 1);
      }}
      opened={kycStatusUpdateOpen}
      setOpened={setKycStatusUpdateOpen}
      availableActions={[
        {
          value: "review",
          label: "Review"
        },
        {
          value: "approve",
          label: "Approve"
        },

      ]
      }
      handleSubmit={
        async (customerKyc: Customer, action: string, token?: string) => {
          const kycCollection = collection(db, "customers", customerKyc.id!, "kyc");
          const kycQuery = query(kycCollection, orderBy("created", "desc"),);
          const kycsList = await getDocs(kycQuery);
          const kycID = kycsList.docs[0]
          await kycAction({
            action: (action as ActionType)!,
            kycID: kycID.id || "",
            customerID: customerKyc.id,
            token: token!,
          });

        }


      }
      renderErrors={(failedItem: any) =>
        <>
          {failedItem.name_en}

          <Space h="xl" />

        </>
      }
      getItemsData={

        (action: string, rows: Customer[]) => {


          let data: Customer[] = []


          if (action === "review")
            data = rows.filter((kyc: Customer) => {
              return kyc?.tags?.kycStatus.code === "review" || kyc?.tags?.kycStatus.code === "client_update"
            })
          if (action === "approve") {
            data = rows.filter((kyc: Customer) => {
              console.log("kyc?.tags?.kycStatus.code  =======>>>", kyc?.tags?.kycStatus.code);
              return kyc?.tags?.kycStatus.code === "approval" || kyc?.tags?.kycStatus.code === "exec_approval"
            }
            )

          }
          if (action === "operations_approve")
            data = rows.filter((kyc: Customer) => kyc?.tags?.kycStatus.code === "processing")

          return data

        }
      }
    />
    <GenerateConfirmedOrdersCSVModal
      opened={generateCSVOpen}
      setOpened={setGenerateCSVOpen}
    />
    <GenerateKycCSVModal
      opened={generateCustomersCSVOpen}
      setOpened={setCustomersGenerateCSVOpen}
    />
    <GenerateBurganExcelModal
      setOpened={setCustomersGenerateBurganExcelOpen}
      opened={generateCustomersBurganExcelOpen}
    />

  </>,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedRows, SMSOpened, addClientModal, generatePDFOpen, kycStatusUpdateOpen, generateCSVOpen, generateCustomersCSVOpen, generateCustomersBurganExcelOpen,]);

  return (
    <>
      <Group justify="space-between" >
        <Title>Clients</Title>
        <Group justify="flex-end">
          <Button
            leftSection={<BsPlusCircle />}
            onClick={() => setAddClientModal(true)}
          >
            Add client
          </Button>
          {canSendPromotionalMaterial && <Button
            color={"grape"}
            leftSection={<IconMessage />}
            onClick={() => setPromotionalMaterialModalOpen(true)}
          >
            Send Promotional Material
          </Button>}
          {(customClaims.admin || customClaims.oper || customClaims.kfh_oper) && <Button
            onClick={() => setCustomersGenerateCSVOpen(true)}
            leftSection={<IconDownload size={14} />}
          >
            Generate Customers CSV
          </Button>}
        </Group>
      </Group>
      <Space h="xl" />
      {customerModals}

      <Card shadow="sm" p="lg" radius="md" withBorder>
        <Grid justify="space-between">

          <Grid.Col>

            {searchableCustomers}
          </Grid.Col>
        </Grid>
        {renderPromotionalMaterialModal}

      </Card>
    </>
  );
};

export default CustomersListTypesense;
